function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/model/documentselection
 */
import mix from '@ckeditor/ckeditor5-utils/src/mix';
import EmitterMixin from '@ckeditor/ckeditor5-utils/src/emittermixin';
import Selection from './selection';
import LiveRange from './liverange';
import Text from './text';
import TextProxy from './textproxy';
import toMap from '@ckeditor/ckeditor5-utils/src/tomap';
import Collection from '@ckeditor/ckeditor5-utils/src/collection';
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
import uid from '@ckeditor/ckeditor5-utils/src/uid';
var storePrefix = 'selection:';
/**
 * `DocumentSelection` is a special selection which is used as the
 * {@link module:engine/model/document~Document#selection document's selection}.
 * There can be only one instance of `DocumentSelection` per document.
 *
 * Document selection can only be changed by using the {@link module:engine/model/writer~Writer} instance
 * inside the {@link module:engine/model/model~Model#change `change()`} block, as it provides a secure way to modify model.
 *
 * `DocumentSelection` is automatically updated upon changes in the {@link module:engine/model/document~Document document}
 * to always contain valid ranges. Its attributes are inherited from the text unless set explicitly.
 *
 * Differences between {@link module:engine/model/selection~Selection} and `DocumentSelection` are:
 * * there is always a range in `DocumentSelection` - even if no ranges were added there is a "default range"
 * present in the selection,
 * * ranges added to this selection updates automatically when the document changes,
 * * attributes of `DocumentSelection` are updated automatically according to selection ranges.
 *
 * Since `DocumentSelection` uses {@link module:engine/model/liverange~LiveRange live ranges}
 * and is updated when {@link module:engine/model/document~Document document}
 * changes, it cannot be set on {@link module:engine/model/node~Node nodes}
 * that are inside {@link module:engine/model/documentfragment~DocumentFragment document fragment}.
 * If you need to represent a selection in document fragment,
 * use {@link module:engine/model/selection~Selection Selection class} instead.
 *
 * @mixes module:utils/emittermixin~EmitterMixin
 */

var DocumentSelection = /*#__PURE__*/function () {
  /**
   * Creates an empty live selection for given {@link module:engine/model/document~Document}.
   *
   * @param {module:engine/model/document~Document} doc Document which owns this selection.
   */
  function DocumentSelection(doc) {
    _classCallCheck(this, DocumentSelection);

    /**
     * Selection used internally by that class (`DocumentSelection` is a proxy to that selection).
     *
     * @protected
     */
    this._selection = new LiveSelection(doc);

    this._selection.delegate('change:range').to(this);

    this._selection.delegate('change:attribute').to(this);

    this._selection.delegate('change:marker').to(this);
  }
  /**
   * Returns whether the selection is collapsed. Selection is collapsed when there is exactly one range which is
   * collapsed.
   *
   * @readonly
   * @type {Boolean}
   */


  _createClass(DocumentSelection, [{
    key: "isCollapsed",
    get: function get() {
      return this._selection.isCollapsed;
    }
    /**
     * Selection anchor. Anchor may be described as a position where the most recent part of the selection starts.
     * Together with {@link #focus} they define the direction of selection, which is important
     * when expanding/shrinking selection. Anchor is always {@link module:engine/model/range~Range#start start} or
     * {@link module:engine/model/range~Range#end end} position of the most recently added range.
     *
     * Is set to `null` if there are no ranges in selection.
     *
     * @see #focus
     * @readonly
     * @type {module:engine/model/position~Position|null}
     */

  }, {
    key: "anchor",
    get: function get() {
      return this._selection.anchor;
    }
    /**
     * Selection focus. Focus is a position where the selection ends.
     *
     * Is set to `null` if there are no ranges in selection.
     *
     * @see #anchor
     * @readonly
     * @type {module:engine/model/position~Position|null}
     */

  }, {
    key: "focus",
    get: function get() {
      return this._selection.focus;
    }
    /**
     * Returns number of ranges in selection.
     *
     * @readonly
     * @type {Number}
     */

  }, {
    key: "rangeCount",
    get: function get() {
      return this._selection.rangeCount;
    }
    /**
     * Describes whether `Documentselection` has own range(s) set, or if it is defaulted to
     * {@link module:engine/model/document~Document#_getDefaultRange document's default range}.
     *
     * @readonly
     * @type {Boolean}
     */

  }, {
    key: "hasOwnRange",
    get: function get() {
      return this._selection.hasOwnRange;
    }
    /**
     * Specifies whether the {@link #focus}
     * precedes {@link #anchor}.
     *
     * @readonly
     * @type {Boolean}
     */

  }, {
    key: "isBackward",
    get: function get() {
      return this._selection.isBackward;
    }
    /**
     * Describes whether the gravity is overridden (using {@link module:engine/model/writer~Writer#overrideSelectionGravity}) or not.
     *
     * Note that the gravity remains overridden as long as will not be restored the same number of times as it was overridden.
     *
     * @readonly
     * @returns {Boolean}
     */

  }, {
    key: "isGravityOverridden",
    get: function get() {
      return this._selection.isGravityOverridden;
    }
    /**
     * A collection of selection {@link module:engine/model/markercollection~Marker markers}.
     * Marker is a selection marker when selection range is inside the marker range.
     *
     * **Note**: Only markers from {@link ~DocumentSelection#observeMarkers observed markers groups} are collected.
     *
     * @readonly
     * @type {module:utils/collection~Collection}
     */

  }, {
    key: "markers",
    get: function get() {
      return this._selection.markers;
    }
    /**
     * Used for the compatibility with the {@link module:engine/model/selection~Selection#isEqual} method.
     *
     * @protected
     */

  }, {
    key: "_ranges",
    get: function get() {
      return this._selection._ranges;
    }
    /**
     * Returns an iterable that iterates over copies of selection ranges.
     *
     * @returns {Iterable.<module:engine/model/range~Range>}
     */

  }, {
    key: "getRanges",
    value: function getRanges() {
      return this._selection.getRanges();
    }
    /**
     * Returns the first position in the selection.
     * First position is the position that {@link module:engine/model/position~Position#isBefore is before}
     * any other position in the selection.
     *
     * Returns `null` if there are no ranges in selection.
     *
     * @returns {module:engine/model/position~Position|null}
     */

  }, {
    key: "getFirstPosition",
    value: function getFirstPosition() {
      return this._selection.getFirstPosition();
    }
    /**
     * Returns the last position in the selection.
     * Last position is the position that {@link module:engine/model/position~Position#isAfter is after}
     * any other position in the selection.
     *
     * Returns `null` if there are no ranges in selection.
     *
     * @returns {module:engine/model/position~Position|null}
     */

  }, {
    key: "getLastPosition",
    value: function getLastPosition() {
      return this._selection.getLastPosition();
    }
    /**
     * Returns a copy of the first range in the selection.
     * First range is the one which {@link module:engine/model/range~Range#start start} position
     * {@link module:engine/model/position~Position#isBefore is before} start position of all other ranges
     * (not to confuse with the first range added to the selection).
     *
     * Returns `null` if there are no ranges in selection.
     *
     * @returns {module:engine/model/range~Range|null}
     */

  }, {
    key: "getFirstRange",
    value: function getFirstRange() {
      return this._selection.getFirstRange();
    }
    /**
     * Returns a copy of the last range in the selection.
     * Last range is the one which {@link module:engine/model/range~Range#end end} position
     * {@link module:engine/model/position~Position#isAfter is after} end position of all other ranges (not to confuse with the range most
     * recently added to the selection).
     *
     * Returns `null` if there are no ranges in selection.
     *
     * @returns {module:engine/model/range~Range|null}
     */

  }, {
    key: "getLastRange",
    value: function getLastRange() {
      return this._selection.getLastRange();
    }
    /**
     * Gets elements of type {@link module:engine/model/schema~Schema#isBlock "block"} touched by the selection.
     *
     * This method's result can be used for example to apply block styling to all blocks covered by this selection.
     *
     * **Note:** `getSelectedBlocks()` returns blocks that are nested in other non-block elements
     * but will not return blocks nested in other blocks.
     *
     * In this case the function will return exactly all 3 paragraphs (note: `<blockQuote>` is not a block itself):
     *
     *		<paragraph>[a</paragraph>
     *		<blockQuote>
     *			<paragraph>b</paragraph>
     *		</blockQuote>
     *		<paragraph>c]d</paragraph>
     *
     * In this case the paragraph will also be returned, despite the collapsed selection:
     *
     *		<paragraph>[]a</paragraph>
     *
     * In such a scenario, however, only blocks A, B & E will be returned as blocks C & D are nested in block B:
     *
     *		[<blockA></blockA>
     *		<blockB>
     *			<blockC></blockC>
     *			<blockD></blockD>
     *		</blockB>
     *		<blockE></blockE>]
     *
     * If the selection is inside a block all the inner blocks (A & B) are returned:
     *
     * 		<block>
     *			<blockA>[a</blockA>
     * 			<blockB>b]</blockB>
     * 		</block>
     *
     * **Special case**: If a selection ends at the beginning of a block, that block is not returned as from user perspective
     * this block wasn't selected. See [#984](https://github.com/ckeditor/ckeditor5-engine/issues/984) for more details.
     *
     *		<paragraph>[a</paragraph>
     *		<paragraph>b</paragraph>
     *		<paragraph>]c</paragraph> // this block will not be returned
     *
     * @returns {Iterable.<module:engine/model/element~Element>}
     */

  }, {
    key: "getSelectedBlocks",
    value: function getSelectedBlocks() {
      return this._selection.getSelectedBlocks();
    }
    /**
     * Returns the selected element. {@link module:engine/model/element~Element Element} is considered as selected if there is only
     * one range in the selection, and that range contains exactly one element.
     * Returns `null` if there is no selected element.
     *
     * @returns {module:engine/model/element~Element|null}
     */

  }, {
    key: "getSelectedElement",
    value: function getSelectedElement() {
      return this._selection.getSelectedElement();
    }
    /**
     * Checks whether the selection contains the entire content of the given element. This means that selection must start
     * at a position {@link module:engine/model/position~Position#isTouching touching} the element's start and ends at position
     * touching the element's end.
     *
     * By default, this method will check whether the entire content of the selection's current root is selected.
     * Useful to check if e.g. the user has just pressed <kbd>Ctrl</kbd> + <kbd>A</kbd>.
     *
     * @param {module:engine/model/element~Element} [element=this.anchor.root]
     * @returns {Boolean}
     */

  }, {
    key: "containsEntireContent",
    value: function containsEntireContent(element) {
      return this._selection.containsEntireContent(element);
    }
    /**
     * Unbinds all events previously bound by document selection.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this._selection.destroy();
    }
    /**
     * Returns iterable that iterates over this selection's attribute keys.
     *
     * @returns {Iterable.<String>}
     */

  }, {
    key: "getAttributeKeys",
    value: function getAttributeKeys() {
      return this._selection.getAttributeKeys();
    }
    /**
     * Returns iterable that iterates over this selection's attributes.
     *
     * Attributes are returned as arrays containing two items. First one is attribute key and second is attribute value.
     * This format is accepted by native `Map` object and also can be passed in `Node` constructor.
     *
     * @returns {Iterable.<*>}
     */

  }, {
    key: "getAttributes",
    value: function getAttributes() {
      return this._selection.getAttributes();
    }
    /**
     * Gets an attribute value for given key or `undefined` if that attribute is not set on the selection.
     *
     * @param {String} key Key of attribute to look for.
     * @returns {*} Attribute value or `undefined`.
     */

  }, {
    key: "getAttribute",
    value: function getAttribute(key) {
      return this._selection.getAttribute(key);
    }
    /**
     * Checks if the selection has an attribute for given key.
     *
     * @param {String} key Key of attribute to check.
     * @returns {Boolean} `true` if attribute with given key is set on selection, `false` otherwise.
     */

  }, {
    key: "hasAttribute",
    value: function hasAttribute(key) {
      return this._selection.hasAttribute(key);
    }
    /**
     * Refreshes selection attributes and markers according to the current position in the model.
     */

  }, {
    key: "refresh",
    value: function refresh() {
      this._selection._updateMarkers();

      this._selection._updateAttributes(false);
    }
    /**
     * Registers a marker group prefix or a marker name to be collected in the
     * {@link ~DocumentSelection#markers selection markers collection}.
     *
     * See also {@link module:engine/model/markercollection~MarkerCollection#getMarkersGroup `MarkerCollection#getMarkersGroup()`}.
     *
     * @param {String} prefixOrName The marker group prefix or marker name.
     */

  }, {
    key: "observeMarkers",
    value: function observeMarkers(prefixOrName) {
      this._selection.observeMarkers(prefixOrName);
    }
    /**
     * Checks whether this object is of the given type.
     *
     *		selection.is( 'selection' ); // -> true
     *		selection.is( 'documentSelection' ); // -> true
     *		selection.is( 'model:selection' ); // -> true
     *		selection.is( 'model:documentSelection' ); // -> true
     *
     *		selection.is( 'view:selection' ); // -> false
     *		selection.is( 'element' ); // -> false
     *		selection.is( 'node' ); // -> false
     *
     * {@link module:engine/model/node~Node#is Check the entire list of model objects} which implement the `is()` method.
     *
     * @param {String} type
     * @returns {Boolean}
     */

  }, {
    key: "is",
    value: function is(type) {
      return type === 'selection' || type == 'model:selection' || type == 'documentSelection' || type == 'model:documentSelection';
    }
    /**
     * Moves {@link module:engine/model/documentselection~DocumentSelection#focus} to the specified location.
     * Should be used only within the {@link module:engine/model/writer~Writer#setSelectionFocus} method.
     *
     * The location can be specified in the same form as
     * {@link module:engine/model/writer~Writer#createPositionAt writer.createPositionAt()} parameters.
     *
     * @see module:engine/model/writer~Writer#setSelectionFocus
     * @protected
     * @param {module:engine/model/item~Item|module:engine/model/position~Position} itemOrPosition
     * @param {Number|'end'|'before'|'after'} [offset] Offset or one of the flags. Used only when
     * first parameter is a {@link module:engine/model/item~Item model item}.
     */

  }, {
    key: "_setFocus",
    value: function _setFocus(itemOrPosition, offset) {
      this._selection.setFocus(itemOrPosition, offset);
    }
    /**
     * Sets this selection's ranges and direction to the specified location based on the given
     * {@link module:engine/model/selection~Selectable selectable}.
     * Should be used only within the {@link module:engine/model/writer~Writer#setSelection} method.
     *
     * @see module:engine/model/writer~Writer#setSelection
     * @protected
     * @param {module:engine/model/selection~Selectable} selectable
     * @param {Number|'before'|'end'|'after'|'on'|'in'} [placeOrOffset] Sets place or offset of the selection.
     * @param {Object} [options]
     * @param {Boolean} [options.backward] Sets this selection instance to be backward.
     */

  }, {
    key: "_setTo",
    value: function _setTo(selectable, placeOrOffset, options) {
      this._selection.setTo(selectable, placeOrOffset, options);
    }
    /**
     * Sets attribute on the selection. If attribute with the same key already is set, it's value is overwritten.
     * Should be used only within the {@link module:engine/model/writer~Writer#setSelectionAttribute} method.
     *
     * @see module:engine/model/writer~Writer#setSelectionAttribute
     * @protected
     * @param {String} key Key of the attribute to set.
     * @param {*} value Attribute value.
     */

  }, {
    key: "_setAttribute",
    value: function _setAttribute(key, value) {
      this._selection.setAttribute(key, value);
    }
    /**
     * Removes an attribute with given key from the selection.
     * If the given attribute was set on the selection, fires the {@link module:engine/model/selection~Selection#event:change:range}
     * event with removed attribute key.
     * Should be used only within the {@link module:engine/model/writer~Writer#removeSelectionAttribute} method.
     *
     * @see module:engine/model/writer~Writer#removeSelectionAttribute
     * @protected
     * @param {String} key Key of the attribute to remove.
     */

  }, {
    key: "_removeAttribute",
    value: function _removeAttribute(key) {
      this._selection.removeAttribute(key);
    }
    /**
     * Returns an iterable that iterates through all selection attributes stored in current selection's parent.
     *
     * @protected
     * @returns {Iterable.<*>}
     */

  }, {
    key: "_getStoredAttributes",
    value: function _getStoredAttributes() {
      return this._selection._getStoredAttributes();
    }
    /**
     * Temporarily changes the gravity of the selection from the left to the right.
     *
     * The gravity defines from which direction the selection inherits its attributes. If it's the default left
     * gravity, the selection (after being moved by the the user) inherits attributes from its left hand side.
     * This method allows to temporarily override this behavior by forcing the gravity to the right.
     *
     * It returns an unique identifier which is required to restore the gravity. It guarantees the symmetry
     * of the process.
     *
     * @see module:engine/model/writer~Writer#overrideSelectionGravity
     * @protected
     * @returns {String} The unique id which allows restoring the gravity.
     */

  }, {
    key: "_overrideGravity",
    value: function _overrideGravity() {
      return this._selection.overrideGravity();
    }
    /**
     * Restores the {@link ~DocumentSelection#_overrideGravity overridden gravity}.
     *
     * Restoring the gravity is only possible using the unique identifier returned by
     * {@link ~DocumentSelection#_overrideGravity}. Note that the gravity remains overridden as long as won't be restored
     * the same number of times it was overridden.
     *
     * @see module:engine/model/writer~Writer#restoreSelectionGravity
     * @protected
     * @param {String} uid The unique id returned by {@link #_overrideGravity}.
     */

  }, {
    key: "_restoreGravity",
    value: function _restoreGravity(uid) {
      this._selection.restoreGravity(uid);
    }
    /**
     * Generates and returns an attribute key for selection attributes store, basing on original attribute key.
     *
     * @protected
     * @param {String} key Attribute key to convert.
     * @returns {String} Converted attribute key, applicable for selection store.
     */

  }], [{
    key: "_getStoreAttributeKey",
    value: function _getStoreAttributeKey(key) {
      return storePrefix + key;
    }
    /**
     * Checks whether the given attribute key is an attribute stored on an element.
     *
     * @protected
     * @param {String} key
     * @returns {Boolean}
     */

  }, {
    key: "_isStoreAttributeKey",
    value: function _isStoreAttributeKey(key) {
      return key.startsWith(storePrefix);
    }
  }]);

  return DocumentSelection;
}();

export { DocumentSelection as default };
mix(DocumentSelection, EmitterMixin);
/**
 * Fired when selection range(s) changed.
 *
 * @event change:range
 * @param {Boolean} directChange In case of {@link module:engine/model/selection~Selection} class it is always set
 * to `true` which indicates that the selection change was caused by a direct use of selection's API.
 * The {@link module:engine/model/documentselection~DocumentSelection}, however, may change because its position
 * was directly changed through the {@link module:engine/model/writer~Writer writer} or because its position was
 * changed because the structure of the model has been changed (which means an indirect change).
 * The indirect change does not occur in case of normal (detached) selections because they are "static" (as "not live")
 * which mean that they are not updated once the document changes.
 */

/**
 * Fired when selection attribute changed.
 *
 * @event change:attribute
 * @param {Boolean} directChange In case of {@link module:engine/model/selection~Selection} class it is always set
 * to `true` which indicates that the selection change was caused by a direct use of selection's API.
 * The {@link module:engine/model/documentselection~DocumentSelection}, however, may change because its attributes
 * were directly changed through the {@link module:engine/model/writer~Writer writer} or because its position was
 * changed in the model and its attributes were refreshed (which means an indirect change).
 * The indirect change does not occur in case of normal (detached) selections because they are "static" (as "not live")
 * which mean that they are not updated once the document changes.
 * @param {Array.<String>} attributeKeys Array containing keys of attributes that changed.
 */

/**
 * Fired when selection marker(s) changed.
 *
 * @event change:marker
 * @param {Boolean} directChange This is always set to `false` in case of `change:marker` event as there is no possibility
 * to change markers directly through {@link module:engine/model/documentselection~DocumentSelection} API.
 * See also {@link module:engine/model/documentselection~DocumentSelection#event:change:range} and
 * {@link module:engine/model/documentselection~DocumentSelection#event:change:attribute}.
 * @param {Array.<module:engine/model/markercollection~Marker>} oldMarkers Markers in which the selection was before the change.
 */
// `LiveSelection` is used internally by {@link module:engine/model/documentselection~DocumentSelection} and shouldn't be used directly.
//
// LiveSelection` is automatically updated upon changes in the {@link module:engine/model/document~Document document}
// to always contain valid ranges. Its attributes are inherited from the text unless set explicitly.
//
// Differences between {@link module:engine/model/selection~Selection} and `LiveSelection` are:
// * there is always a range in `LiveSelection` - even if no ranges were added there is a "default range"
// present in the selection,
// * ranges added to this selection updates automatically when the document changes,
// * attributes of `LiveSelection` are updated automatically according to selection ranges.
//
// @extends module:engine/model/selection~Selection
//

var LiveSelection = /*#__PURE__*/function (_Selection) {
  _inherits(LiveSelection, _Selection);

  var _super = _createSuper(LiveSelection);

  // Creates an empty live selection for given {@link module:engine/model/document~Document}.
  // @param {module:engine/model/document~Document} doc Document which owns this selection.
  function LiveSelection(doc) {
    var _this;

    _classCallCheck(this, LiveSelection);

    _this = _super.call(this); // List of selection markers.
    // Marker is a selection marker when selection range is inside the marker range.
    //
    // @type {module:utils/collection~Collection}

    _this.markers = new Collection({
      idProperty: 'name'
    }); // Document which owns this selection.
    //
    // @protected
    // @member {module:engine/model/model~Model}

    _this._model = doc.model; // Document which owns this selection.
    //
    // @protected
    // @member {module:engine/model/document~Document}

    _this._document = doc; // Keeps mapping of attribute name to priority with which the attribute got modified (added/changed/removed)
    // last time. Possible values of priority are: `'low'` and `'normal'`.
    //
    // Priorities are used by internal `LiveSelection` mechanisms. All attributes set using `LiveSelection`
    // attributes API are set with `'normal'` priority.
    //
    // @private
    // @member {Map} module:engine/model/liveselection~LiveSelection#_attributePriority

    _this._attributePriority = new Map(); // Position to which the selection should be set if the last selection range was moved to the graveyard.
    // @private
    // @member {module:engine/model/position~Position} module:engine/model/liveselection~LiveSelection#_selectionRestorePosition

    _this._selectionRestorePosition = null; // Flag that informs whether the selection ranges have changed. It is changed on true when `LiveRange#change:range` event is fired.
    // @private
    // @member {Array} module:engine/model/liveselection~LiveSelection#_hasChangedRange

    _this._hasChangedRange = false; // Each overriding gravity adds an UID to the set and each removal removes it.
    // Gravity is overridden when there's at least one UID in the set.
    // Gravity is restored when the set is empty.
    // This is to prevent conflicts when gravity is overridden by more than one feature at the same time.
    // @private
    // @type {Set}

    _this._overriddenGravityRegister = new Set(); // Prefixes of marker names that should affect `LiveSelection#markers` collection.
    // @private
    // @type {Set}

    _this._observedMarkers = new Set(); // Ensure selection is correct after each operation.

    _this.listenTo(_this._model, 'applyOperation', function (evt, args) {
      var operation = args[0];

      if (!operation.isDocumentOperation || operation.type == 'marker' || operation.type == 'rename' || operation.type == 'noop') {
        return;
      } // Fix selection if the last range was removed from it and we have a position to which we can restore the selection.


      if (_this._ranges.length == 0 && _this._selectionRestorePosition) {
        _this._fixGraveyardSelection(_this._selectionRestorePosition);
      } // "Forget" the restore position even if it was not "used".


      _this._selectionRestorePosition = null;

      if (_this._hasChangedRange) {
        _this._hasChangedRange = false;

        _this.fire('change:range', {
          directChange: false
        });
      }
    }, {
      priority: 'lowest'
    }); // Ensure selection is correct and up to date after each range change.


    _this.on('change:range', function () {
      var _iterator = _createForOfIteratorHelper(_this.getRanges()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var range = _step.value;

          if (!_this._document._validateSelectionRange(range)) {
            /**
             * Range from {@link module:engine/model/documentselection~DocumentSelection document selection}
             * starts or ends at incorrect position.
             *
             * @error document-selection-wrong-position
             * @param {module:engine/model/range~Range} range
             */
            throw new CKEditorError('document-selection-wrong-position', _assertThisInitialized(_this), {
              range: range
            });
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }); // Update markers data stored by the selection after each marker change.
    // This handles only marker changes done through marker operations (not model tree changes).


    _this.listenTo(_this._model.markers, 'update', function (evt, marker, oldRange, newRange) {
      _this._updateMarker(marker, newRange);
    }); // Ensure selection is up to date after each change block.


    _this.listenTo(_this._document, 'change', function (evt, batch) {
      clearAttributesStoredInElement(_this._model, batch);
    });

    return _this;
  }

  _createClass(LiveSelection, [{
    key: "isCollapsed",
    get: function get() {
      var length = this._ranges.length;
      return length === 0 ? this._document._getDefaultRange().isCollapsed : _get(_getPrototypeOf(LiveSelection.prototype), "isCollapsed", this);
    }
  }, {
    key: "anchor",
    get: function get() {
      return _get(_getPrototypeOf(LiveSelection.prototype), "anchor", this) || this._document._getDefaultRange().start;
    }
  }, {
    key: "focus",
    get: function get() {
      return _get(_getPrototypeOf(LiveSelection.prototype), "focus", this) || this._document._getDefaultRange().end;
    }
  }, {
    key: "rangeCount",
    get: function get() {
      return this._ranges.length ? this._ranges.length : 1;
    } // Describes whether `LiveSelection` has own range(s) set, or if it is defaulted to
    // {@link module:engine/model/document~Document#_getDefaultRange document's default range}.
    //
    // @readonly
    // @type {Boolean}

  }, {
    key: "hasOwnRange",
    get: function get() {
      return this._ranges.length > 0;
    } // When set to `true` then selection attributes on node before the caret won't be taken
    // into consideration while updating selection attributes.
    //
    // @protected
    // @type {Boolean}

  }, {
    key: "isGravityOverridden",
    get: function get() {
      return !!this._overriddenGravityRegister.size;
    } // Unbinds all events previously bound by live selection.

  }, {
    key: "destroy",
    value: function destroy() {
      for (var i = 0; i < this._ranges.length; i++) {
        this._ranges[i].detach();
      }

      this.stopListening();
    }
  }, {
    key: "getRanges",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function getRanges() {
      return _regeneratorRuntime.wrap(function getRanges$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!this._ranges.length) {
                _context.next = 4;
                break;
              }

              return _context.delegateYield(_get(_getPrototypeOf(LiveSelection.prototype), "getRanges", this).call(this), "t0", 2);

            case 2:
              _context.next = 6;
              break;

            case 4:
              _context.next = 6;
              return this._document._getDefaultRange();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, getRanges, this);
    })
  }, {
    key: "getFirstRange",
    value: function getFirstRange() {
      return _get(_getPrototypeOf(LiveSelection.prototype), "getFirstRange", this).call(this) || this._document._getDefaultRange();
    }
  }, {
    key: "getLastRange",
    value: function getLastRange() {
      return _get(_getPrototypeOf(LiveSelection.prototype), "getLastRange", this).call(this) || this._document._getDefaultRange();
    }
  }, {
    key: "setTo",
    value: function setTo(selectable, optionsOrPlaceOrOffset, options) {
      _get(_getPrototypeOf(LiveSelection.prototype), "setTo", this).call(this, selectable, optionsOrPlaceOrOffset, options);

      this._updateAttributes(true);

      this._updateMarkers();
    }
  }, {
    key: "setFocus",
    value: function setFocus(itemOrPosition, offset) {
      _get(_getPrototypeOf(LiveSelection.prototype), "setFocus", this).call(this, itemOrPosition, offset);

      this._updateAttributes(true);

      this._updateMarkers();
    }
  }, {
    key: "setAttribute",
    value: function setAttribute(key, value) {
      if (this._setAttribute(key, value)) {
        // Fire event with exact data.
        var attributeKeys = [key];
        this.fire('change:attribute', {
          attributeKeys: attributeKeys,
          directChange: true
        });
      }
    }
  }, {
    key: "removeAttribute",
    value: function removeAttribute(key) {
      if (this._removeAttribute(key)) {
        // Fire event with exact data.
        var attributeKeys = [key];
        this.fire('change:attribute', {
          attributeKeys: attributeKeys,
          directChange: true
        });
      }
    }
  }, {
    key: "overrideGravity",
    value: function overrideGravity() {
      var overrideUid = uid(); // Remember that another overriding has been requested. It will need to be removed
      // before the gravity is to be restored.

      this._overriddenGravityRegister.add(overrideUid);

      if (this._overriddenGravityRegister.size === 1) {
        this._updateAttributes(true);
      }

      return overrideUid;
    }
  }, {
    key: "restoreGravity",
    value: function restoreGravity(uid) {
      if (!this._overriddenGravityRegister.has(uid)) {
        /**
         * Restoring gravity for an unknown UID is not possible. Make sure you are using a correct
         * UID obtained from the {@link module:engine/model/writer~Writer#overrideSelectionGravity} to restore.
         *
         * @error document-selection-gravity-wrong-restore
         * @param {String} uid The unique identifier returned by
         * {@link module:engine/model/documentselection~DocumentSelection#_overrideGravity}.
         */
        throw new CKEditorError('document-selection-gravity-wrong-restore', this, {
          uid: uid
        });
      }

      this._overriddenGravityRegister.delete(uid); // Restore gravity only when all overriding have been restored.


      if (!this.isGravityOverridden) {
        this._updateAttributes(true);
      }
    }
  }, {
    key: "observeMarkers",
    value: function observeMarkers(prefixOrName) {
      this._observedMarkers.add(prefixOrName);

      this._updateMarkers();
    }
  }, {
    key: "_popRange",
    value: function _popRange() {
      this._ranges.pop().detach();
    }
  }, {
    key: "_pushRange",
    value: function _pushRange(range) {
      var liveRange = this._prepareRange(range); // `undefined` is returned when given `range` is in graveyard root.


      if (liveRange) {
        this._ranges.push(liveRange);
      }
    } // Prepares given range to be added to selection. Checks if it is correct,
    // converts it to {@link module:engine/model/liverange~LiveRange LiveRange}
    // and sets listeners listening to the range's change event.
    //
    // @private
    // @param {module:engine/model/range~Range} range

  }, {
    key: "_prepareRange",
    value: function _prepareRange(range) {
      var _this2 = this;

      this._checkRange(range);

      if (range.root == this._document.graveyard) {
        // @if CK_DEBUG // console.warn( 'Trying to add a Range that is in the graveyard root. Range rejected.' );
        return;
      }

      var liveRange = LiveRange.fromRange(range); // If selection range is moved to the graveyard remove it from the selection object.
      // Also, save some data that can be used to restore selection later, on `Model#applyOperation` event.

      liveRange.on('change:range', function (evt, oldRange, data) {
        _this2._hasChangedRange = true;

        if (liveRange.root == _this2._document.graveyard) {
          _this2._selectionRestorePosition = data.deletionPosition;

          var index = _this2._ranges.indexOf(liveRange);

          _this2._ranges.splice(index, 1);

          liveRange.detach();
        }
      });
      return liveRange;
    }
  }, {
    key: "_updateMarkers",
    value: function _updateMarkers() {
      if (!this._observedMarkers.size) {
        return;
      }

      var markers = [];
      var changed = false;

      var _iterator2 = _createForOfIteratorHelper(this._model.markers),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _marker2 = _step2.value;

          var markerGroup = _marker2.name.split(':', 1)[0];

          if (!this._observedMarkers.has(markerGroup)) {
            continue;
          }

          var markerRange = _marker2.getRange();

          var _iterator3 = _createForOfIteratorHelper(this.getRanges()),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var selectionRange = _step3.value;

              if (markerRange.containsRange(selectionRange, !selectionRange.isCollapsed)) {
                markers.push(_marker2);
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var oldMarkers = Array.from(this.markers);

      for (var _i = 0, _markers = markers; _i < _markers.length; _i++) {
        var marker = _markers[_i];

        if (!this.markers.has(marker)) {
          this.markers.add(marker);
          changed = true;
        }
      }

      for (var _i2 = 0, _Array$from = Array.from(this.markers); _i2 < _Array$from.length; _i2++) {
        var _marker = _Array$from[_i2];

        if (!markers.includes(_marker)) {
          this.markers.remove(_marker);
          changed = true;
        }
      }

      if (changed) {
        this.fire('change:marker', {
          oldMarkers: oldMarkers,
          directChange: false
        });
      }
    }
  }, {
    key: "_updateMarker",
    value: function _updateMarker(marker, markerRange) {
      var markerGroup = marker.name.split(':', 1)[0];

      if (!this._observedMarkers.has(markerGroup)) {
        return;
      }

      var changed = false;
      var oldMarkers = Array.from(this.markers);
      var hasMarker = this.markers.has(marker);

      if (!markerRange) {
        if (hasMarker) {
          this.markers.remove(marker);
          changed = true;
        }
      } else {
        var contained = false;

        var _iterator4 = _createForOfIteratorHelper(this.getRanges()),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var selectionRange = _step4.value;

            if (markerRange.containsRange(selectionRange, !selectionRange.isCollapsed)) {
              contained = true;
              break;
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        if (contained && !hasMarker) {
          this.markers.add(marker);
          changed = true;
        } else if (!contained && hasMarker) {
          this.markers.remove(marker);
          changed = true;
        }
      }

      if (changed) {
        this.fire('change:marker', {
          oldMarkers: oldMarkers,
          directChange: false
        });
      }
    } // Updates this selection attributes according to its ranges and the {@link module:engine/model/document~Document model document}.
    //
    // @protected
    // @param {Boolean} clearAll
    // @fires change:attribute

  }, {
    key: "_updateAttributes",
    value: function _updateAttributes(clearAll) {
      var newAttributes = toMap(this._getSurroundingAttributes());
      var oldAttributes = toMap(this.getAttributes());

      if (clearAll) {
        // If `clearAll` remove all attributes and reset priorities.
        this._attributePriority = new Map();
        this._attrs = new Map();
      } else {
        // If not, remove only attributes added with `low` priority.
        var _iterator5 = _createForOfIteratorHelper(this._attributePriority),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _ref3 = _step5.value;

            var _ref2 = _slicedToArray(_ref3, 2);

            var key = _ref2[0];
            var priority = _ref2[1];

            if (priority == 'low') {
              this._attrs.delete(key);

              this._attributePriority.delete(key);
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }

      this._setAttributesTo(newAttributes); // Let's evaluate which attributes really changed.


      var changed = []; // First, loop through all attributes that are set on selection right now.
      // Check which of them are different than old attributes.

      var _iterator6 = _createForOfIteratorHelper(this.getAttributes()),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _ref8 = _step6.value;

          var _ref5 = _slicedToArray(_ref8, 2);

          var newKey = _ref5[0];
          var newValue = _ref5[1];

          if (!oldAttributes.has(newKey) || oldAttributes.get(newKey) !== newValue) {
            changed.push(newKey);
          }
        } // Then, check which of old attributes got removed.

      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      var _iterator7 = _createForOfIteratorHelper(oldAttributes),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _ref9 = _step7.value;

          var _ref7 = _slicedToArray(_ref9, 1);

          var oldKey = _ref7[0];

          if (!this.hasAttribute(oldKey)) {
            changed.push(oldKey);
          }
        } // Fire event with exact data (fire only if anything changed).

      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      if (changed.length > 0) {
        this.fire('change:attribute', {
          attributeKeys: changed,
          directChange: false
        });
      }
    } // Internal method for setting `LiveSelection` attribute. Supports attribute priorities (through `directChange`
    // parameter).
    //
    // @private
    // @param {String} key Attribute key.
    // @param {*} value Attribute value.
    // @param {Boolean} [directChange=true] `true` if the change is caused by `Selection` API, `false` if change
    // is caused by `Batch` API.
    // @returns {Boolean} Whether value has changed.

  }, {
    key: "_setAttribute",
    value: function _setAttribute(key, value) {
      var directChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var priority = directChange ? 'normal' : 'low';

      if (priority == 'low' && this._attributePriority.get(key) == 'normal') {
        // Priority too low.
        return false;
      }

      var oldValue = _get(_getPrototypeOf(LiveSelection.prototype), "getAttribute", this).call(this, key); // Don't do anything if value has not changed.


      if (oldValue === value) {
        return false;
      }

      this._attrs.set(key, value); // Update priorities map.


      this._attributePriority.set(key, priority);

      return true;
    } // Internal method for removing `LiveSelection` attribute. Supports attribute priorities (through `directChange`
    // parameter).
    //
    // NOTE: Even if attribute is not present in the selection but is provided to this method, it's priority will
    // be changed according to `directChange` parameter.
    //
    // @private
    // @param {String} key Attribute key.
    // @param {Boolean} [directChange=true] `true` if the change is caused by `Selection` API, `false` if change
    // is caused by `Batch` API.
    // @returns {Boolean} Whether attribute was removed. May not be true if such attributes didn't exist or the
    // existing attribute had higher priority.

  }, {
    key: "_removeAttribute",
    value: function _removeAttribute(key) {
      var directChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var priority = directChange ? 'normal' : 'low';

      if (priority == 'low' && this._attributePriority.get(key) == 'normal') {
        // Priority too low.
        return false;
      } // Update priorities map.


      this._attributePriority.set(key, priority); // Don't do anything if value has not changed.


      if (!_get(_getPrototypeOf(LiveSelection.prototype), "hasAttribute", this).call(this, key)) {
        return false;
      }

      this._attrs.delete(key);

      return true;
    } // Internal method for setting multiple `LiveSelection` attributes. Supports attribute priorities (through
    // `directChange` parameter).
    //
    // @private
    // @param {Map.<String,*>} attrs Iterable object containing attributes to be set.
    // @returns {Set.<String>} Changed attribute keys.

  }, {
    key: "_setAttributesTo",
    value: function _setAttributesTo(attrs) {
      var changed = new Set();

      var _iterator8 = _createForOfIteratorHelper(this.getAttributes()),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _ref14 = _step8.value;

          var _ref11 = _slicedToArray(_ref14, 2);

          var oldKey = _ref11[0];
          var oldValue = _ref11[1];

          // Do not remove attribute if attribute with same key and value is about to be set.
          if (attrs.get(oldKey) === oldValue) {
            continue;
          } // All rest attributes will be removed so changed attributes won't change .


          this._removeAttribute(oldKey, false);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      var _iterator9 = _createForOfIteratorHelper(attrs),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var _ref15 = _step9.value;

          var _ref13 = _slicedToArray(_ref15, 2);

          var key = _ref13[0];
          var value = _ref13[1];

          // Attribute may not be set because of attributes or because same key/value is already added.
          var gotAdded = this._setAttribute(key, value, false);

          if (gotAdded) {
            changed.add(key);
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      return changed;
    } // Returns an iterable that iterates through all selection attributes stored in current selection's parent.
    //
    // @protected
    // @returns {Iterable.<*>}

  }, {
    key: "_getStoredAttributes",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _getStoredAttributes() {
      var selectionParent, _iterator10, _step10, key, realKey;

      return _regeneratorRuntime.wrap(function _getStoredAttributes$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              selectionParent = this.getFirstPosition().parent;

              if (!(this.isCollapsed && selectionParent.isEmpty)) {
                _context2.next = 21;
                break;
              }

              _iterator10 = _createForOfIteratorHelper(selectionParent.getAttributeKeys());
              _context2.prev = 3;

              _iterator10.s();

            case 5:
              if ((_step10 = _iterator10.n()).done) {
                _context2.next = 13;
                break;
              }

              key = _step10.value;

              if (!key.startsWith(storePrefix)) {
                _context2.next = 11;
                break;
              }

              realKey = key.substr(storePrefix.length);
              _context2.next = 11;
              return [realKey, selectionParent.getAttribute(key)];

            case 11:
              _context2.next = 5;
              break;

            case 13:
              _context2.next = 18;
              break;

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](3);

              _iterator10.e(_context2.t0);

            case 18:
              _context2.prev = 18;

              _iterator10.f();

              return _context2.finish(18);

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _getStoredAttributes, this, [[3, 15, 18, 21]]);
    }) // Checks model text nodes that are closest to the selection's first position and returns attributes of first
    // found element. If there are no text nodes in selection's first position parent, it returns selection
    // attributes stored in that parent.
    //
    // @private
    // @returns {Iterable.<*>} Collection of attributes.

  }, {
    key: "_getSurroundingAttributes",
    value: function _getSurroundingAttributes() {
      var position = this.getFirstPosition();
      var schema = this._model.schema;
      var attrs = null;

      if (!this.isCollapsed) {
        // 1. If selection is a range...
        var range = this.getFirstRange(); // ...look for a first character node in that range and take attributes from it.

        var _iterator11 = _createForOfIteratorHelper(range),
            _step11;

        try {
          for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
            var value = _step11.value;

            // If the item is an object, we don't want to get attributes from its children.
            if (value.item.is('element') && schema.isObject(value.item)) {
              break;
            }

            if (value.type == 'text') {
              attrs = value.item.getAttributes();
              break;
            }
          }
        } catch (err) {
          _iterator11.e(err);
        } finally {
          _iterator11.f();
        }
      } else {
        // 2. If the selection is a caret or the range does not contain a character node...
        var nodeBefore = position.textNode ? position.textNode : position.nodeBefore;
        var nodeAfter = position.textNode ? position.textNode : position.nodeAfter; // When gravity is overridden then don't take node before into consideration.

        if (!this.isGravityOverridden) {
          // ...look at the node before caret and take attributes from it if it is a character node.
          attrs = getAttrsIfCharacter(nodeBefore);
        } // 3. If not, look at the node after caret...


        if (!attrs) {
          attrs = getAttrsIfCharacter(nodeAfter);
        } // 4. If not, try to find the first character on the left, that is in the same node.
        // When gravity is overridden then don't take node before into consideration.


        if (!this.isGravityOverridden && !attrs) {
          var node = nodeBefore;

          while (node && !schema.isInline(node) && !attrs) {
            node = node.previousSibling;
            attrs = getAttrsIfCharacter(node);
          }
        } // 5. If not found, try to find the first character on the right, that is in the same node.


        if (!attrs) {
          var _node = nodeAfter;

          while (_node && !schema.isInline(_node) && !attrs) {
            _node = _node.nextSibling;
            attrs = getAttrsIfCharacter(_node);
          }
        } // 6. If not found, selection should retrieve attributes from parent.


        if (!attrs) {
          attrs = this._getStoredAttributes();
        }
      }

      return attrs;
    } // Fixes the selection after all its ranges got removed.
    //
    // @private
    // @param {module:engine/model/position~Position} deletionPosition Position where the deletion happened.

  }, {
    key: "_fixGraveyardSelection",
    value: function _fixGraveyardSelection(deletionPosition) {
      // Find a range that is a correct selection range and is closest to the position where the deletion happened.
      var selectionRange = this._model.schema.getNearestSelectionRange(deletionPosition); // If nearest valid selection range has been found - add it in the place of old range.


      if (selectionRange) {
        // Check the range, convert it to live range, bind events, etc.
        this._pushRange(selectionRange);
      } // If nearest valid selection range cannot be found don't add any range. Selection will be set to the default range.

    }
  }]);

  return LiveSelection;
}(Selection); // Helper function for {@link module:engine/model/liveselection~LiveSelection#_updateAttributes}.
//
// It takes model item, checks whether it is a text node (or text proxy) and, if so, returns it's attributes. If not, returns `null`.
//
// @param {module:engine/model/item~Item|null}  node
// @returns {Boolean}


function getAttrsIfCharacter(node) {
  if (node instanceof TextProxy || node instanceof Text) {
    return node.getAttributes();
  }

  return null;
} // Removes selection attributes from element which is not empty anymore.
//
// @param {module:engine/model/model~Model} model
// @param {module:engine/model/batch~Batch} batch


function clearAttributesStoredInElement(model, batch) {
  var differ = model.document.differ;

  var _iterator12 = _createForOfIteratorHelper(differ.getChanges()),
      _step12;

  try {
    var _loop = function _loop() {
      var entry = _step12.value;

      if (entry.type != 'insert') {
        return "continue";
      }

      var changeParent = entry.position.parent;
      var isNoLongerEmpty = entry.length === changeParent.maxOffset;

      if (isNoLongerEmpty) {
        model.enqueueChange(batch, function (writer) {
          var storedAttributes = Array.from(changeParent.getAttributeKeys()).filter(function (key) {
            return key.startsWith(storePrefix);
          });

          var _iterator13 = _createForOfIteratorHelper(storedAttributes),
              _step13;

          try {
            for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
              var key = _step13.value;
              writer.removeAttribute(key, changeParent);
            }
          } catch (err) {
            _iterator13.e(err);
          } finally {
            _iterator13.f();
          }
        });
      }
    };

    for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
      var _ret = _loop();

      if (_ret === "continue") continue;
    }
  } catch (err) {
    _iterator12.e(err);
  } finally {
    _iterator12.f();
  }
}